/*
 * Copyright (C) 2026. to Present Applause App Quality, Inc. All rights reserved.
 */

/**
 * utest-fe and tester-app are both served under *.utest.com subdomains and share a LogRocket
 * App ID -- rootHostname lets LogRocket link sessions/identify() across them.
 * See https://docs.logrocket.com/reference/roothostname.
 *
 * Exported so app.module.ts (which passes it to LogRocket.init) and the cookie cleanup below
 * cannot drift apart: the cookie names LogRocket writes are derived from this value.
 */
export const LOGROCKET_ROOT_HOSTNAME = '.utest.com';

/**
 * The exact cookies LogRocket writes, derived from the recorder's own naming:
 *
 *   cookieName(kind) => `${prefix}${base}-${appID}`
 *
 * where `base` is one of `_lr_hb_` (heartbeat) or `_lr_tabs_` (session-info) -- those are the
 * only two -- and `prefix` is `${btoa(rootHostname)}-`, applied only when rootHostname is a
 * valid ancestor of the current host. On localhost that check fails and the SDK falls back to
 * the unprefixed name, so both variants are returned.
 *
 * Note this means the names do NOT start with `_lr_` in any deployed environment, and that the
 * App ID is part of the name, so prod's cookies are distinct from integration/stage's and are
 * left alone. `_lr_id_`, `_lr_dat_`, `_lr_misc_` and `_lr5_` are localStorage keys, not cookies.
 */
export function logRocketCookieNames(appId: string): string[] {
  const names = ['_lr_hb_', '_lr_tabs_'].map((base) => `${base}-${appId}`);
  return [...names, ...names.map((name) => `${btoa(LOGROCKET_ROOT_HOSTNAME)}-${name}`)];
}
